import { Grid, SxProps, Typography } from "@mui/material";
import React from "react";
import { EquipmentAdjustment } from "../../Objects/EquipmentAdjustment";
import { StudioAdjustment } from "../../Objects/StudioAdjustment";

export interface ReserveTotalProps {
    studioAdjustmentList: StudioAdjustment[]
    equipmentAdjustmentList: EquipmentAdjustment[]
    sx?: SxProps
}

const ReserveTotal: React.FC<ReserveTotalProps> = ({
    studioAdjustmentList,
    equipmentAdjustmentList,
    sx,
}) => {

    /**
     * View
     */
    return (
        <Grid container
            sx={sx}
        >
            <Grid item
                xs={6}
            >
                <Typography>合計</Typography>
            </Grid>
            <Grid item
                xs={6}
            >
                <Typography align="right">{studioAdjustmentList.reduce((sum: number, item: StudioAdjustment) => {
                    return sum + item.chrptn_charge
                }, equipmentAdjustmentList.reduce((sum: number, item: EquipmentAdjustment) => {
                    return sum + item.charge
                }, 0)).toLocaleString()}円</Typography>
            </Grid>
        </Grid>
    )
}

export default ReserveTotal